// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"116":"193b61e6","120":"314f0ff4","932":"29bb4237","995":"b2aa14dc"}[chunkId] + ".js";
};